"use strict";

export class FadeAnimation {
    /**
     * コンストラクタ
     * @param {string} targetSelector - 監視対象のセレクタ(デフォルトは '.js-fade')
     */
    constructor(targetSelector = '.js-fade') {
        this.fadeElements = document.querySelectorAll(targetSelector);
        this.observer = null;
    }


    init() {
        // 対象の要素が存在しない場合は処理をスキップ(エラー防止)
        if (this.fadeElements.length === 0) return;

        // Intersection Observer の初期化
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // 画面内に入ったらクラスを付与
                    entry.target.classList.add('is-show');
                    // 一度表示されたら監視を解除
                    this.observer.unobserve(entry.target);
                }
            });
        }, {
            root: null,
            rootMargin: '0px 0px -15% 0px',
            threshold: 0
        });

        // 全ての要素の監視を開始
        this.fadeElements.forEach(el => this.observer.observe(el));
    }
}